module.exports = __webpack_public_path__ + "img/drivedatawalluser.ba42201f.png";